import React, {useState} from "react";
import Modal from "react-responsive-modal";
import ModalUploadDocument from "./ModalUploadDocument";

export const UploadDocumentResult = {
    CANCEL: 'cancel',
    SAVED: 'saved',
}

export const UploadDocumentMode = {
    UPLOAD: 'upload',
    DELETE: 'delete',
}

const useModalUploadDocument = () =>
{
    const [dialog, setDialog]  = useState ( { openState: false, provider_id: null, enc_doc_id: null, onSaveCompleted: null, mode: null })   ;

    const onClick = ( provider_id, mode, enc_doc_id, onCompleteFunction ) =>
    {
        setDialog ({ openState: true, provider_id: provider_id, enc_doc_id: enc_doc_id, onSaveCompleted: onCompleteFunction, mode: mode });
    }

    const doClose = ( result ) =>
    {
        // Tell the parent we're done
        if ( dialog.onSaveCompleted != null )
        {
            dialog.onSaveCompleted( result ) ;
        }

        setDialog ({ openState: false, provider_id: null, enc_doc_id: null, onSaveCompleted: null, mode: null });
    }

    const onCloseModal = () =>
    {
        doClose( UploadDocumentResult.CANCEL );
    };

    const onSaveComplete = () =>
    {
        doClose( UploadDocumentResult.SAVED );
    };

    const render = () =>
    {
        return (
            <Modal center focusTrapped={false} open={dialog.openState} closeOnOverlayClick={false} onClose={onCloseModal}>
                <ModalUploadDocument onSaveCompleted={onSaveComplete} onClose={onCloseModal} provider_id={dialog.provider_id} enc_doc_id={dialog.enc_doc_id} params={dialog} mode={dialog.mode} />
            </Modal>
        )
    }

    return [ render, onClick ] ;
}

export default useModalUploadDocument ;
